if (!customElements.get('product-details-tabs')) {
  customElements.define(
    'product-details-tabs',
    class ProductDetailsTabs extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('[data-details-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-details-panel]'));

        if (!this.links.length || !this.panels.length) return;

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);

        this.links.forEach((link) => link.addEventListener('click', this.onLinkClick));
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);

        this.refreshPanelPositions();
        this.updateActiveLink();

        if (document.fonts?.ready) {
          document.fonts.ready.then(() => {
            this.refreshPanelPositions();
            this.updateActiveLink();
          });
        }

        Array.from(this.querySelectorAll('img')).forEach((image) => {
          if (!image.complete) image.addEventListener('load', this.onResize, { once: true });
        });
      }

      disconnectedCallback() {
        this.links?.forEach((link) => link.removeEventListener('click', this.onLinkClick));
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.resizeTimer);
      }

      onLinkClick(event) {
        const targetId = event.currentTarget.hash.slice(1);
        const target = document.getElementById(targetId);

        if (!target) return;

        event.preventDefault();

        const top = target.getBoundingClientRect().top + window.scrollY - this.getStickyOffset();
        window.scrollTo({ top, behavior: 'smooth' });
        window.history.replaceState(null, '', `#${targetId}`);
      }

      onScroll() {
        if (this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {
          this.updateActiveLink();
          this.scrollFrame = null;
        });
      }

      onResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.refreshPanelPositions();
          this.updateActiveLink();
        }, 100);
      }

      getStickyOffset() {
        const navigationHeight = this.querySelector('.product-details-tabs__nav')?.offsetHeight || 0;
        const header = document.querySelector('.section-header');
        const headerIsVisible =
          header?.classList.contains('shopify-section-header-sticky') &&
          !header.classList.contains('shopify-section-header-hidden');
        const headerHeight = headerIsVisible ? header.offsetHeight : 0;

        return navigationHeight + headerHeight + 16;
      }

      refreshPanelPositions() {
        this.panelPositions = this.panels.map((panel) => ({
          id: panel.id,
          top: panel.getBoundingClientRect().top + window.scrollY,
        }));
      }

      updateActiveLink() {
        if (!this.panelPositions?.length) this.refreshPanelPositions();

        const marker = window.scrollY + this.getStickyOffset() + 24;
        let activeId = this.panelPositions[0].id;

        this.panelPositions.forEach((panel) => {
          if (marker >= panel.top) activeId = panel.id;
        });

        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
          activeId = this.panelPositions[this.panelPositions.length - 1].id;
        }

        this.links.forEach((link) => {
          const isActive = link.hash === `#${activeId}`;
          link.classList.toggle('is-active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
